<template>
  <div id="SoftwareDisplay" class="software-display">
    <el-popover placement="bottom" trigger="hover" width="272">
      <div class="software-popover">
        <p v-for="item in softwareArr" :key="item.softwareCode" class="line">
          <img :src="require(`@/assets/img/icon-software/${item.softwareCode.toLowerCase()}.png`)" class="icon-software" alt="">
          <span>{{ formatDisplay(item.softwareName) }}</span>
        </p>
      </div>
      <div class="flex-align-center" slot="reference">
        <img v-for="item in softwareShowIcons" :key="item.softwareCode" :src="require(`@/assets/img/icon-software/${item.softwareCode.toLowerCase()}.png`)" alt="">
        <span v-if="hideNumber > 0" class="hide-number">{{ `+${hideNumber}` }}</span>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'SoftwareDisplay',
  props: {
    softwareArr: {
      type: Array,
      default() {
        return []
      }
    },
    softwareVersionName: {
      type: [Number, String],
      default: ''
    },
    // 展示几个图标，默认false即，展示出所有icon图标
    showIconCount: {
      type: [Number, Boolean],
      default: false
    },
  },
  computed: {
    hideNumber() {
      return this.showIconCount ? this.softwareArr.length - this.showIconCount : 0
    },
    softwareShowIcons() {
      return this.showIconCount ? this.softwareArr.slice(0, this.showIconCount) : this.softwareArr
    }
  },
  methods: {
    formatDisplay(softwareName) {
      return this.softwareVersionName ? `${softwareName || ''}_${this.softwareVersionName}` : `${softwareName || ''}`
    },
  },
}
</script>

<style lang="less" scoped>
.software-display{
  display: inline-block;
}
.software-popover{
  .line{
    display: flex;
    flex-direction: row;
    align-items: center;
    line-height: 24px;
  }
  .icon-software{
    margin-right: 4px;
  }
}
.hide-number{
  display: inline-block;
  width: 20px;
  height:20px;
  line-height: 20px;
  text-align: center;
  font-size: 12px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.1);
  color: #3D3D3D;
  margin-left: 4px;
}
</style>
